import type { AccountantEmail } from 'types/accountant.types';

/**
 * Gets the default email from an array of AccountantEmail objects.
 * Falls back to the first email when no default is set.
 * @param emails - Array of AccountantEmail objects
 * @returns The email string, or empty string if not available
 */
export function getDefaultEmail(
  emails: AccountantEmail[] | undefined | null,
): string {
  if (!emails || emails.length === 0) {
    return '';
  }

  const defaultEmail = emails.find((emailObj) => emailObj.default === true);
  return defaultEmail?.email ?? emails[0]?.email ?? '';
}
